import { cx } from "cva";
import { Fragment } from "react";

import { Badge } from "../Badge";
import { applyIconColor, IconButtonProps, variants } from "./";
import styles from "./index.module.css";
export const IconButton = ({
  className,
  children,
  type = "button",
  variant = "solid",
  size,
  color,
  number,
  text,
  shadow,
  disabled,
  ...props
}: IconButtonProps) => {
  const badgeVariant = variant === "solid" ? "lighted" : "solid";
  const badgeColor = variant !== "solid" && color === "key" ? "primary" : undefined;

  const coloredIcon = applyIconColor({ icon: children, variant, color, disabled });

  return (
    <button type={type} className={cx(styles.button, className)} disabled={disabled} {...props}>
      <span className={variants({ variant, color, size, shadow })}>
        {coloredIcon}
        {!!number && (
          <Badge number={number} variant={badgeVariant} size="s" color={badgeColor} className={styles.badge} />
        )}
      </span>
      {!!text && (
        <p className={styles.text}>
          {text.split(/<br\s*\/?>/i).map((line, index) => (
            <Fragment key={index}>
              {line}
              <br />
            </Fragment>
          ))}
        </p>
      )}
    </button>
  );
};
